import { createStyleSheet } from '@shared-ui/theme'
import type { ViewStyle } from 'react-native'

export const useCreateStyles = createStyleSheet(() => ({
  action: {
    userSelect: 'none',
    cursor: 'pointer',
  } as unknown as ViewStyle,
  actionSelectable: {
    userSelect: 'text',
  } as unknown as ViewStyle,
  actionDisabled: {
    cursor: 'default',
  } as unknown as ViewStyle,
}))
